import React from 'react';
import { useParams } from 'react-router-dom';

const TenderDetail = () => {
  const { id } = useParams();
  return (
    <div data-testid="tender-detail-page">
      <div className="bg-card rounded-xl shadow-sm border border-border p-8">
        <h2 className="text-xl font-semibold mb-4">Upphandlingsanalys</h2>
        <p className="text-muted-foreground">Tender ID: {id}</p>
      </div>
    </div>
  );
};

export default TenderDetail;
